import {
  Add,
  Work,
  PictureAsPdf,
  Lock,
  LockOpen,
  Group,
  Event,
} from "@mui/icons-material";

import { useTheme } from "@mui/material/styles";
import { memo } from "react";
import { useEventManagerContext } from "../../context/eventContext";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";
import KsbToolbarAdmin from "../../../../2_ksbHub/components/KsbToolbarAdmin";
import KsbToolbarUser from "../../../../2_ksbHub/components/KsbToolbarUser";
import KsbSelector from "../../../../2_ksbHub/components/KsbSelector";
import EventLockChip from "../locks/EventLockChip";
import EventLockInfo from "../locks/EventLockInfo";
import useViewOptions from "../../hooks/useViewOptions";
import useEventPDF from "../../hooks/useEventPDF";
import KsbAppToolbarContainer from "../../../../2_ksbHub/components/KsbAppToolbarContainer";
import { Box } from "@mui/material";

function EventManagerHeader({
  viewMode,
  setViewMode,
  dialogs, // ✅ NEW
}) {
  const theme = useTheme();

  const { isTeacherView, isMobile } = useAppContext();

  const {
    schoolyears,
    selectedSchoolyear,
    setSelectedSchoolyear,
    events,
    selectedEvent,
    setSelectedEvent,
    isAnEventManagerAdmin,
  } = useEventManagerContext();

  const { generatePDF, generateParticipantPDF } = useEventPDF();

  const viewOptions = useViewOptions();

  const hasAnyLock =
    selectedEvent?.lockForStudents || selectedEvent?.lockForTeachers;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <KsbAppToolbarContainer isAdmin={isAnEventManagerAdmin}>
        {/* ✅ USER */}
        <KsbToolbarUser>
          <KsbSelector
            value={viewMode}
            options={viewOptions}
            getValue={(v) => v.id}
            getLabel={(v) => v.label}
            onChange={setViewMode}
          />

          {schoolyears.length > 0 && (
            <KsbSelector
              value={selectedSchoolyear?.id}
              options={schoolyears}
              getValue={(y) => y.id}
              getLabel={(y) => (isMobile ? y.label.slice(2) : y.label)}
              onChange={(id) => {
                const sy = schoolyears.find((y) => y.id === id);
                if (sy) setSelectedSchoolyear(sy);
              }}
            />
          )}

          {events.length > 0 && (
            <KsbSelector
              value={selectedEvent?.id}
              options={events}
              getValue={(e) => e.id}
              getLabel={(e) => (isMobile ? e.label.slice(0, 6) : e.label)}
              getExtra={(event) => <EventLockInfo roles={event.roles} />}
              onChange={(id) => {
                const ev = events.find((x) => x.id === id);
                if (ev) setSelectedEvent(ev);
              }}
            />
          )}

          {isAnEventManagerAdmin && !isTeacherView && <EventLockChip />}
        </KsbToolbarUser>

        {/* ✅ ADMIN */}
        {isAnEventManagerAdmin && !isTeacherView && (
          <KsbToolbarAdmin>
            {/* CREATE EVENT */}
            <KsbActionButton
              onClick={() => dialogs.setCreateEventOpen(true)}
              icon={<Event />}
              label="Neuer Event"
              color={theme.palette.eventManager.slot.mine}
            />

            {/* CREATE SHIFT */}
            <KsbActionButton
              onClick={() => dialogs.setCreateShiftOpen(true)}
              icon={<Add />}
              label="Neue Schicht"
            />

            {/* CREATE JOB */}
            <KsbActionButton
              onClick={() => dialogs.setCreateJobOpen(true)}
              icon={<Work />}
              label="Neuer Job"
            />

            {/* PDF */}
            <KsbActionButton
              onClick={generatePDF}
              icon={<PictureAsPdf />}
              label="Einsatzplan"
              color={theme.palette.text.primary}
            />

            {/* PARTICIPANTS */}
            <KsbActionButton
              onClick={generateParticipantPDF}
              icon={<Group />}
              label="Personenliste"
            />

            {/* LOCK */}
            <KsbActionButton
              onClick={() => dialogs.setLockDialogOpen(true)}
              icon={hasAnyLock ? <LockOpen /> : <Lock />}
              label={hasAnyLock ? "Freigeben" : "Sperren"}
              color={
                hasAnyLock
                  ? theme.palette.success.main
                  : theme.palette.warning.main
              }
            />
          </KsbToolbarAdmin>
        )}
      </KsbAppToolbarContainer>
    </Box>
  );
}

export default memo(EventManagerHeader);
